// Кольцо «сколько из скольких»: одно число, на которое смотрят первым.
//
// ## Когда этот вид уместен, а когда нет
//
// Только там, где у величины есть ЕСТЕСТВЕННЫЙ потолок и доля от него что-то значит:
// укомплектованность (людей на постах из требуемых), готовность выплат (переведено из всего
// к выплате). Для величины без потолка кольцо врёт: «долгов на полтора миллиона» — это не
// доля ни от чего, и рисовать её частью круга значит выдумать целое.
//
// ## Почему кольцо, а не полоса
//
// Полоса доли в продукте уже есть и стоит в строках списков — там, где долей МНОГО и их
// сравнивают между собой. Кольцо отвечает на другой вопрос: одна доля, и она — ответ всего
// блока. Разные вопросы, разные виды; путать их значит вернуться к «каждый экран рисует
// одно и то же по-своему».
//
// Вид взят из набора AlignUI (`widget-time-off`): полукольцо, число по центру, подпись под ним.

import { GaugeChart } from '@/shared/ui/chart-gauge';

export interface ДоляОтЦелогоProps {
  /** Сколько есть. */
  value: number;
  /** Из скольких. Ноль означает «целое неизвестно» — кольца тогда не будет. */
  max: number;
  /** Что написано под числом: «из 145 по постам». Единица обязана быть в тексте. */
  подпись: string;
  /** Что показать вместо кольца, когда целое неизвестно. */
  когдаНеизвестно?: string;
}

export function ДоляОтЦелого({ value, max, подпись, когдаНеизвестно }: ДоляОтЦелогоProps) {
  if (max <= 0) {
    // Ноль в знаменателе — это НЕ «ноль процентов». Пустое кольцо человек читает как
    // «укомплектованность нулевая», то есть как катастрофу, которой нет (правило 7).
    return (
      <p className='py-6 text-center text-paragraph-sm text-text-sub-600'>
        {когдаНеизвестно ?? 'Считать не от чего: целое ещё не задано.'}
      </p>
    );
  }
  const процент = Math.round((value / max) * 100);

  return (
    <div className='flex flex-col items-center gap-2 py-6'>
      <div className='grid w-52'>
        <GaugeChart
          data={{ name: 'доля', value: Math.min(value, max) }}
          max={max}
          className='[grid-area:1/1]'
        />
        {/* Внутри кольца стоит ТОЛЬКО процент. В исходнике набора туда же кладут и подпись —
            там она короткая («OUT OF 20»), а у нас «59 из 64 объектов закрыты полностью»
            переносится на две строки и уезжает под дугу: на живом экране цифры читались
            сквозь фиолетовую полосу. Подпись вынесена под кольцо, где ей не тесно. */}
        <div className='pointer-events-none relative z-10 flex items-end justify-center [grid-area:1/1]'>
          <span className='text-title-h4 tabular-nums text-text-strong-950'>{процент}%</span>
        </div>
      </div>
      <span className='max-w-sm text-center text-paragraph-xs text-text-sub-600'>{подпись}</span>
    </div>
  );
}
